export default "__VITE_ASSET__D_CJoyT4__"